import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/digital/model_bottom.png';
const _withScopeId = n => (_pushScopeId("data-v-4f417f45"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "file-content"
};
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = {
  class: "video-box"
};
const _hoisted_4 = {
  ref: "video",
  autoplay: "",
  controls: "",
  muted: "",
  loop: "",
  preload: "auto",
  "x5-playsinline": "true",
  "x5-video-player-type": "h5-page",
  "webkit-playsinline": "true",
  playsinline: "true"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "file-icon file-icon-video"
};
const _hoisted_7 = {
  class: "file-num"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "file-box",
  ref: "imgBox"
};
const _hoisted_11 = {
  class: "img-box"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "model-bottom",
  src: _imports_0
}, null, -1));
const _hoisted_13 = {
  key: 1,
  class: "img"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = {
  class: "file-icon"
};
const _hoisted_16 = {
  class: "file-num"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_CompModel = _resolveComponent("CompModel");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$props.detail.nft_type == 3 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("video", _hoisted_4, [_createElementVNode("source", {
    src: $data.videoUrl
  }, null, 8, _hoisted_5)], 512), _withDirectives(_createElementVNode("div", {
    class: "video-cover",
    style: _normalizeStyle(`background-image: url('${$props.detail.img_url}')`)
  }, [_createElementVNode("img", {
    class: "play-icon",
    onClick: _cache[0] || (_cache[0] = _withModifiers((...args) => $options.videoPlay && $options.videoPlay(...args), ["stop"])),
    src: "https://s.moimg.net/m/images/video-play.png"
  })], 4), [[_vShow, $data.showPlayIcon]])]), _withDirectives(_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString($props.detail.seq) + "/" + _toDisplayString($props.detail.amount), 1)]), $props.detail.merge_info && $props.detail.merge_info.title ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "file-btn",
    onClick: _cache[1] || (_cache[1] = (...args) => $options.goToInfo && $options.goToInfo(...args))
  }, _toDisplayString($props.detail.merge_info.title), 1)) : _createCommentVNode("", true)], 512), [[_vShow, $data.showIcon]])])) : (_openBlock(), _createElementBlock("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [$props.detail.nft_type == 2 ? (_openBlock(), _createElementBlock(_Fragment, {
    key: 0
  }, [_hoisted_12, _createVNode(_component_CompModel, {
    modelUrl: $props.file.glb_model
  }, null, 8, ["modelUrl"])], 64)) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("img", {
    class: "img-cont",
    src: $props.file.img
  }, null, 8, _hoisted_14)]))])], 512), _withDirectives(_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString($props.detail.seq) + "/" + _toDisplayString($props.detail.amount), 1)]), $props.detail.merge_info && $props.detail.merge_info.title ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    class: "file-btn",
    onClick: _cache[2] || (_cache[2] = (...args) => $options.goToInfo && $options.goToInfo(...args))
  }, _toDisplayString($props.detail.merge_info.title), 1)) : _createCommentVNode("", true), $props.detail.nft_type == 1 && $props.ifOwner ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "file-view",
    onClick: _cache[3] || (_cache[3] = (...args) => $options.showBig && $options.showBig(...args))
  })) : _createCommentVNode("", true)], 512), [[_vShow, $data.showIcon]])]))]);
}